__turbopack_context__.v({
  "modalContent": "FolderDeleteModal-module__CxyqxG__modalContent",
});
